module.exports = __webpack_public_path__ + "static/media/seloLiveVoala.d0220906.png";